module.exports = __webpack_public_path__ + "static/media/haha.a14eb180.png";